import {Component, OnInit} from '@angular/core';
import {FormService} from "@core/shared/services/form.service";
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {MatSnackBar} from "@angular/material/snack-bar";
import {ActivatedRoute, Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {RegistrationAffiliationService} from "@core/shared/services/registration-affiliation.service";
import {FileConfig} from "@lib/form/fields/file/file.component";
import {ApiService} from "@core/shared/services/api.service";

@Component({
    selector: 'app-core-page-registration-affiliation-create',
    templateUrl: './page-registration-affiliation-create.component.html',
    styleUrls: ['./page-registration-affiliation-create.component.scss'],
    providers: [
        FormService
    ],
    standalone: false
})
export class PageRegistrationAffiliationCreateComponent implements OnInit {

    public origin: { key: string, backLabel: string } = null;

    public registrationLogoConfig: FileConfig;

    public administrationLogoConfig: FileConfig;
    
    public allowedSubscriptions: {id: string, label: string}[] = [
        {
            id: 'starter',
            label: 'subscription.pack.starter.plural.value'
        },
        {
            id: 'premium',
            label: 'subscription.pack.premium.plural.value'
        }
    ];

    public constructor(
        private _formBuilder: UntypedFormBuilder,
        private _snackBar: MatSnackBar,
        private _activatedRoute: ActivatedRoute,
        private _router: Router,
        private _translateService: TranslateService,
        private _registrationAffiliationService: RegistrationAffiliationService,
        private _apiService: ApiService,
        public formService: FormService
    ) {}

    ngOnInit(): void {

        this._initOrigin();

        this._initForm();
    }

    private _initOrigin(): void {

        this.origin = {
            key: this._activatedRoute.snapshot.queryParams['origin'],
            backLabel: `registrationAffiliation.creation.origin.${this._activatedRoute.snapshot.queryParams['origin']}.value`
        };
    }

    private _initForm(): void {

        this.formService.form = this._formBuilder.group({
            name: ['', Validators.required],
            comment: [''],
            allowedSubscriptions: [[], [(control: UntypedFormControl) => {

                if (control.value.length >= 1) {

                    return null;
                }

                return {
                    'minLengthArray': {
                        valid: false
                    }
                };
            }]],
            registrationLogo: [null],
            administrationLogo: [null]
        });

        this.formService.submitCallback = (): void => {

            const data: object = Object.assign(this.form.value, {});

            this._registrationAffiliationService.createItemAPI(data).subscribe((): void => {

                this._snackBar.open(this._translateService.instant('registrationAffiliation.add.success.value'), this._translateService.instant('notification.close.action.value'), {
                    duration: 5000
                });

                this.redirectToOrigin();
            });
        };

        this._initRegistrationLogoConfigs();

        this._initAdministrationLogoConfigs();
    }

    private _initRegistrationLogoConfigs(): void {

        this._translateService.get('file.extension.list.allowed.value', {list: '.png, .jpeg, .svg'}).subscribe((help: string): void => {

            this.registrationLogoConfig = {
                id: 'registrationLogo',
                gallery: {
                    id: null,
                    type: 'file',
                    context: 'registration_affiliation_registration_logo'
                },
                uploadMaxFileSize: 100000,
                required: false,
                uploadApiUrl: this._apiService.getApiUrl(false, true)
            };
        });
    }

    private _initAdministrationLogoConfigs(): void {

        this._translateService.get('file.extension.list.allowed.value', {list: '.png, .jpeg, .svg'}).subscribe((help: string): void => {

            this.administrationLogoConfig = {
                id: 'administrationLogo',
                gallery: {
                    id: null,
                    type: 'file',
                    context: 'registration_affiliation_administration_logo'
                },
                uploadMaxFileSize: 100000,
                required: false,
                uploadApiUrl: this._apiService.getApiUrl(false, true)
            };
        });
    }

    public redirectToOrigin(): void {

        switch (this.origin.key) {

            case 'relationshipList':

                this._router.navigate(['account/relationship/list'], { queryParams: { targetTab: 'affiliation' }});

                break;
        }
    }

    get localeId(): string {

        return this._translateService.currentLang;
    }

    get form(): UntypedFormGroup {

        return this.formService.form;
    }
}
